// components/MobileNavigation/EthicsComplianceSection.tsx
import React from 'react';
import NavItemLink from './NavItemLink';

interface EthicsComplianceSectionProps {
  items: any[];
  activeItem: string;
  onNavClick: (itemId: string) => void;
}

const EthicsComplianceSection: React.FC<EthicsComplianceSectionProps> = ({ items, activeItem, onNavClick }) => {
  return (
    <div className="space-y-1">
      {items.map((subItem) => (
        <NavItemLink
          key={subItem.id}
          item={subItem}
          activeItem={activeItem}
          onNavClick={onNavClick}
        />
      ))}
    </div>
  );
};

export default EthicsComplianceSection;